module.exports = __webpack_public_path__ + "9f57020c1cfaddfe096178982cf35030.svg";